<template>
  <el-drawer
    @close="back"
    v-model="isOpen"
    :title="pageTitle"
    size="500px"
    header-class="drawer-header"
    body-class="drawer-body"
    footer-class="drawer-footer"
  >
    <template #header>
      <slot name="header"></slot>
    </template>
    <slot>
      <el-form
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="100px"
        ref="form-tariff"
        v-loading="loading"
      >
        <el-form-item prop="title" label="Название">
          <el-input ref="title" v-model.trim="form.title"></el-input>
        </el-form-item>
        <el-form-item prop="tariff" label="Тариф(число)">
          <el-input v-model.number="form.tariff"></el-input>
        </el-form-item>
        <el-form-item prop="type" label="Тип">
          <el-select v-model="form.type">
            <el-option :value="1" label="Разметчик"></el-option>
            <el-option :value="2" label="Верификатор"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </slot>
    <template #footer>
      <slot name="footer">
        <div v-loading="loading" class="flex flex-col w-full">
          <div class="flex items-center">
            <el-button
              v-if="form.state === 0"
              @click="toActive"
              plain
              type="success"
              class="w-full"
            >
              Сделать активным
            </el-button>

            <el-button @click="submit" plain type="primary" class="w-full">
              Сохранить
            </el-button>
          </div>
          <div class="flex items-center">
            <el-button
              v-if="form.state === -1"
              @click="restoreTarif"
              type="success"
              plain
              class="w-full mt-3"
            >
              Восстановить
            </el-button>

            <el-button
              v-if="![1, -1].includes(form.state)"
              @click="removeTariff"
              plain
              type="danger"
              class="w-full mt-3"
            >
              Удалить
            </el-button>
          </div>
        </div>
      </slot>
    </template>
  </el-drawer>
</template>

<script>
import {
  createTariff,
  deleteTariff,
  getItemTariff,
  updateTariff,
} from "@/api/tarif";

export default {
  name: "createTarifForm",
  emits: ["getList"],
  props: {
    tarif_id: String,
  },
  popupController: null,
  data() {
    return {
      isOpen: true,
      loading: false,
      form: {
        title: "",
        tariff: null,
        state: 1,
      },
      rules: {
        title: [
          { required: true, message: "Заполните все поля", trigger: "blur" },
        ],
        tariff: [
          {
            required: true,
            message: "Заполните все поля",
            trigger: "blur",
            type: "number",
          },
        ],
        type: [
          { required: true, message: "Заполните все поля", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    pageTitle() {
      return this.tarif_id === "new"
        ? "Создание тарифа"
        : "Редактирование тарифа";
    },
  },
  async created() {
    if (this.tarif_id !== "new") {
      await this.getItemTarif();
    }
    setTimeout(() => {
      this.$nextTick(() => {
        this.$refs.title?.focus();
      });
    }, 300);
  },
  methods: {
    async getItemTarif() {
      this.loading = true;
      try {
        let { data } = await getItemTariff(this.tarif_id);
        this.form = { ...data };
        console.log(data);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.isOpen = false;
      this.$emit("getList");
      this.$router.replace({ name: "tarif" });
    },
    submit() {
      this.$refs["form-tariff"].validate((k) => {
        if (k) {
          if (this.tarif_id !== "new") {
            this.updateTariff();
          } else {
            console.log("we are here");
            this.createTariff();
          }
        }
      });
    },
    async updateTariff() {
      let data = await updateTariff(this.tarif_id, this.form);
      console.log(data);
      if (data._success) {
        this.back();
      }
    },
    async createTariff() {
      let data = await createTariff(this.form);
      console.log(data);
      if (data._success) {
        this.back();
      }
    },
    async restoreTarif() {
      let form = { ...this.form };
      form.state = 1;
      let data = await updateTariff(this.tarif_id, form);
      console.log(data);
      if (data._success) {
        this.form.state = 1;
        this.$emit("backWithUpdate", this.form.state);
        this.back();
      }
    },
    async toActive() {
      let form = { ...this.form };
      form.state = 1;
      let data = await updateTariff(this.tarif_id, form);
      if (data._success) {
        this.back();
      }
    },
    async removeTariff() {
      let form = { ...this.form };
      form.state = -1;
      let data = await deleteTariff(this.tarif_id);
      console.log(data);
      if (data._success) {
        this.form.state = -1;
        this.$emit("backWithUpdate", this.form.state);
        this.back();
      }
    },
  },
};
</script>

<style lang="scss">
.drawer-header {
  @apply bg-gray-50 border-b border-gray-200;
  padding: 16px !important;
}
.drawer-body {
  padding: 16px !important;
}
.drawer-footer {
  @apply bg-gray-50 border-t border-gray-200;
  padding: 16px !important;
}
.el-form:deep(.el-form-item__label) {
  line-height: 20px !important;
}
</style>
